import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import FloatingSocialButtons from "./components/feature/FloatingSocialButtons";
import { HelmetProvider } from "react-helmet-async";
import { SiteContentProvider } from "./cms/SiteContentContext";
import CmsPreviewBridge from "./cms/CmsPreviewBridge";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";
import GoogleTagManager from "./components/analytics/GoogleTagManager";
import MetaPixel from "./components/analytics/MetaPixel";

function App() {
  return (
    <HelmetProvider>
      <SiteContentProvider>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={__BASE_PATH__}>
            <GoogleAnalytics />
            <GoogleTagManager />
            <MetaPixel />
            <CmsPreviewBridge />
            <AppRoutes />
            <FloatingSocialButtons />
          </BrowserRouter>
        </I18nextProvider>
      </SiteContentProvider>
    </HelmetProvider>
  );
}

export default App;
